import { useRef } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import './Navbar.css';
import Logo from './../../assets/logo-text.png';
import LogoS from './../../assets/logo.png';

import { useLocation, Link } from 'react-router-dom';

function Navbar() {
  const navRef = useRef();
  const location = useLocation();

  const bgcolor = location.pathname === '/' ? 'bg-[#060f1c] sticky' : 'bg-[#000B1A]';

  const showNavbar = () => {
    navRef.current.classList.toggle('responsive_nav');
  };

  return (
    <header className={bgcolor}>
      <div className="flex w-full flex-row items-center justify-between">
        <a href="/">
          <div>
            <img alt="" src={Logo} className="w-44 px-4" />
            <img alt="" src={LogoS} className="w-16" />
          </div>
        </a>
        <nav ref={navRef} className="text-xl font-bold">
          <a href="/">Home</a>
          <a href="/team">Team</a>
          <a href="/contact">Contact us</a>
          <button className="nav-btn nav-close-btn" onClick={showNavbar}>
            <Link to={{ pathname: '/', state: { scrollTarget: 'target-component' } }}>
              <FaTimes />
            </Link>
          </button>
        </nav>
      </div>
      <button className="nav-btn" onClick={showNavbar}>
        <Link to={{ pathname: '../home/hero.jsx', state: { scrollTarget: 'target-component' } }}>
          <FaBars />
        </Link>
      </button>
    </header>
  );
}

export default Navbar;
